import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOperation, IOperations } from "../../util/varibles/interface";
import { initialState } from "./constants";

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        getDataRequest: (state) => {
            state.loadingOp = true
        },
        getDataSuccess: (state, action) => {
            state.operations = action.payload;
            state.loadingOp = false
        },
        getDataFailure: (state) => {
            state.loadingOp = false
        },
        updatePositionVessel: (state, action) => {
            const { vessels = [], target = {} } = state;
            const gpsOfVessels = action.payload;

            state.vessels = vessels.map((vessel: any) => {
                if (gpsOfVessels[vessel.id]) {
                    return { ...vessel, gps: { ...vessel.gps, ...gpsOfVessels[vessel.id] } }
                }
                return vessel;
            })

            const { id = null, gps } = target.vessel || {};
            if (id && gpsOfVessels[id])
                state.target = { ...target, vessel: { ...target.vessel, gps: { ...gps || {}, ...gpsOfVessels[id] } } };
        },
        getVesselsRequest: (state, action) => {
            state.loadingVessels = true
        },
        getVesselsSuccess: (state, action) => {
            state.vessels = action.payload
            state.loadingVessels = false
        },
        getVesselsFailure: (state) => {
            state.loadingVessels = false
        },
        togglePopupInfo: (state, action) => {
            const { isShow, values } = action.payload.params;
            return { ...state, popupInfo: { isShow, values } }
        },
        updateOperations: (state, action: PayloadAction<IOperation[]>) => {
            const list = action.payload;
            const { operations } = state;
            list.forEach(item => {
                const { id } = item.operation;
                const index = operations.findIndex(sub => sub.operation.id === id);
                if (index !== -1) {
                    const old = operations[index];
                    const { status, current_process } = item.operation;
                    operations[index] = {
                        ...old,
                        current_process,
                        operation: { ...old.operation, ...item.operation, status },
                        activity_log: item.activity_log
                    };
                } else {
                    operations.push(item)
                }
            })
        },
        showInfo: (state, action) => {
            const target = action.payload;
            const { targetType = null } = target;

            if (targetType === null) {
                state.tracking = false
            }

            state.target = target;
        },
        updateLoadingProdAreas: (state, action) => {
            state.loadingProdAreas = action.payload
        },
        updateProductionAreas: (state, action) => {
            state.productionAreas = action.payload
        },
        updateTracking: (state, action) => {
            state.tracking = action.payload
        },
        updateOpsSite: (state, action: PayloadAction<IOperation[]>) => {
            const ops = action.payload;
            state.opsSite = {
                ...state.opsSite, ...ops.reduce((rs: IOperations, item) => {
                    rs[item.operation.id] = item;
                    return rs;
                }, {})
            }
        },
        updateEtaOperations: (state, action: PayloadAction<{ operation_id: string, time: number, step: string }>) => {
            const { operation_id, time, step } = action.payload;
            const { operations, opsSite } = state;
            const eta = { operation_id, time, step };
            state.operations = operations.map(item => {
                if (item.operation.id === operation_id) {
                    return {
                        ...item,
                        operation: {
                            ...item.operation,
                            eta
                        }
                    }
                }
                return item;
            })

            state.opsSite = Object.keys(opsSite).reduce((rs: typeof opsSite, key) => {
                if (key === operation_id) {
                    rs[key] = {
                        ...opsSite[key],
                        operation: {
                            ...opsSite[key].operation,
                            eta
                        }
                    }
                }
                return rs;
            }, opsSite)
        },
        updateOpsSiteByWs: (_, __: PayloadAction<IOperation[]>) => {
        },
        deleteOps: (state, action: PayloadAction<string[]>) => {
            let { operations, opsSite } = state;
            const ids = new Set(action.payload);
            state.operations = operations.filter(item => !ids.has(item.operation.id));
            const newOpsSite = Object.keys(opsSite).reduce((rs: typeof opsSite, key) => {
                const { id } = opsSite[key].operation;
                if (!ids.has(id))
                    rs[id] = opsSite[key]
                return rs;
            }, {});
            state.opsSite = newOpsSite;
        }
    },
})

export const dashboardActions = dashboardSlice.actions

const dashboardReducer = dashboardSlice.reducer;

export default dashboardReducer;
